import React, { forwardRef, useState } from "react";
import { HiEye, HiEyeOff, HiLockClosed } from "react-icons/hi";

import { Input } from "../../../ui";

type Props = Omit<React.InputHTMLAttributes<HTMLInputElement>, "type"> & {
  wrapperClassName?: string;
};

const PasswordInput = forwardRef<HTMLInputElement, Props>((props, ref) => {
  const [visible, setVisible] = useState(false);
  return (
    <Input
      {...props}
      ref={ref}
      type={visible ? "text" : "password"}
      leadingIcon={<HiLockClosed className="h-4 w-4" />}
      trailingIcon={
        <button
          type="button"
          onClick={() => setVisible((v) => !v)}
          aria-label={visible ? "Hide password" : "Show password"}
          className="pointer-events-auto -mr-1 inline-flex h-6 w-6 items-center justify-center rounded-md text-gray-400 hover:text-gray-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand/25"
        >
          {visible ? <HiEyeOff className="h-4 w-4" /> : <HiEye className="h-4 w-4" />}
        </button>
      }
    />
  );
});

PasswordInput.displayName = "PasswordInput";

export default PasswordInput;
